/**
 * Load a script from a given URL
 *
 *
 * @param url
 * @param id
 * @returns
 */
export const loadScript = (url: string, id: string): Promise<void> => {
  const scriptElement = document.head.querySelector(`#${id}`);

  return new Promise((resolve, reject) => {
    // in case the script exists, but is not loaded yet
    if (scriptElement) {
      scriptElement.addEventListener('load', () => {
        resolve();
      });
      scriptElement.addEventListener('error', () => {
        reject(new Error(`Error loading script: ${url}`));
      });
    } else {
      const script = document.createElement('script');
      script.id = id;
      script.src = url;
      script.type = 'text/javascript';
      script.onload = () => {
        resolve();
      };
      script.onerror = () => {
        reject(new Error(`Error loading script: ${url}`));
      };

      document.head.appendChild(script);
    }
  });
};
